import React from 'react';

export const Process: React.FC = () => {
  const steps = [
    {
      title: "Briefing",
      description: "Wir analysieren deinen Status Quo und definieren die Angriffsziele. Kein unnötiges Blabla, nur Fakten.",
      number: "01"
    },
    {
      title: "Production",
      description: "Unser Team geht in die Execution. Content, Code, Design. Wir bauen die Assets, die du brauchst.",
      number: "02"
    },
    {
      title: "Go Live",
      description: "Launch. Wir schalten die Kampagnen live, optimieren die Funnels und skalieren das Budget.",
      number: "03"
    }
  ];

  return (
    <section id="process" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-4xl md:text-6xl font-black text-brand-dark uppercase tracking-tighter mb-24 text-center animate-fade-in-up opacity-0">
          So läuft's zackig ab.
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 gap-y-16">
          {steps.map((step, index) => (
            <div key={index} className="relative pt-8 animate-fade-in-up opacity-0" style={{ animationDelay: `${0.2 + (index * 0.2)}s` }}>
              <div className="bg-brand-gray rounded-[2rem] p-8 pb-12 h-full relative border border-gray-200 hover:border-brand-orange transition-all duration-500 ease-apple group hover:shadow-2xl hover:-translate-y-2">
                 <div className="absolute -top-10 left-8 w-20 h-20 bg-brand-dark text-white rounded-2xl flex items-center justify-center text-3xl font-black shadow-xl group-hover:bg-brand-orange group-hover:-translate-y-2 transition-all duration-500 ease-apple transform -rotate-3 group-hover:rotate-0">
                    {step.number}
                 </div>
                 <h3 className="text-3xl font-black text-brand-dark mt-8 mb-4 uppercase italic">{step.title}</h3>
                 <p className="text-gray-600 font-medium leading-relaxed">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};